
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import SearchBar from "@/components/ui/SearchBar";

interface NavbarSearchProps {
  isMobile?: boolean;
}

const NavbarSearch = ({ isMobile = false }: NavbarSearchProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  const handleSearch = (query: string) => {
    setSearchQuery(query);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  if (isMobile) {
    return (
      <form onSubmit={handleSubmit} className="relative mt-3 mb-3">
        <SearchBar 
          onSearch={handleSearch} 
          placeholder="Search prompts..." 
          className="w-full"
          triggerMode="submit"
        />
        <Button type="submit" className="mt-2 w-full">Search</Button>
      </form>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="relative flex items-center">
      <SearchBar 
        onSearch={handleSearch} 
        placeholder="Search prompts..." 
        className="w-40 sm:w-64"
        triggerMode="submit"
      />
    </form>
  );
};

export default NavbarSearch;
